module.exports = __webpack_public_path__ + "static/media/amp-guitar.dfb75622.svg";